import { ICustomerLicenseSummary } from "@app/dashboard/dashboard.models";
import { createEntityAdapter } from "@ngrx/entity";

export const customerLicenseSummariesAdapter = createEntityAdapter<ICustomerLicenseSummary>({
	selectId: summary => summary.consumerId
});